export default __webpack_public_path__ + "static/media/cloud3.a2e018d2.png";